<template>

  <div class="padded">

    <el-collapse v-model="activeTab" accordion>

      <el-collapse-item name="summary">
         <template slot="title">
           Summary&nbsp;<i class="header-icon fa fa-info-circle"></i>
         </template>

         <property-charts v-if="showGraph" />

      </el-collapse-item>



      <el-collapse-item name="rental">
        <template slot="title">
          Rental by Month&nbsp;<i class="header-icon fa fa-money"></i>
        </template>

        <property-rental-month />

      </el-collapse-item>



      <el-collapse-item name="due">
        <template slot="title">
          Rental Due&nbsp;<i class="header-icon fa fa-clock"></i>
        </template>

        <tenancy-due />

      </el-collapse-item>



      <el-collapse-item name="expiry">
        <template slot="title">
          Expiring Tenancies&nbsp;<i class="header-icon fa fa-business-time"></i>
        </template>

        <property-expiry />

      </el-collapse-item>



      <el-collapse-item name="landlords" label="Landlords">
        <template slot="title">
          Landlords&nbsp;<i class="header-icon fa fa-home"></i>
        </template>

        <property-landlords />

      </el-collapse-item>

    </el-collapse>



</div>
</template>

<script>

import PropertyCharts from '@/components/dashboard/charts/PropertyCharts'
import PropertyExpiry from '@/components/dashboard/property/PropertyExpiry'
import PropertyLandlords from '@/components/dashboard/property/PropertyLandlords'
import TenancyDue from '@/components/dashboard/property/TenancyDue'
import PropertyRentalMonth from '@/components/dashboard/property/PropertyRentalMonth'

export default {

  props: {
    showGraph: {
      type: Boolean,
      default: true
    }
  },

  components: {
    PropertyCharts,
    PropertyExpiry,
    PropertyLandlords,
    TenancyDue,
    PropertyRentalMonth
  },

  data () {
    return {
      activeTab: 'summary'
    }
  }

}
</script>



// WEBPACK FOOTER //
// PropertyDashboard.vue?24f98dce